export const orderListRoutes = {
  path: 'order-list',
  name: 'OrderList',
  component: () => import('@/views/systemOrder/index.vue'),
  meta: {
    hidden: false,
    title: 'Order List'
  }
}



